import { Doughnut, mixins } from 'vue-chartjs'
import pieceLabel from 'chart.piecelabel.js'
const { reactiveProp } = mixins

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: ['data', 'options'],
  mounted() {
    this.addPlugin({
      id: 'pieceLabel',
      // beforeInit: function (chart) {        
      //   console.log(chart)
      // }
    })
    this.renderChart(this.chartData, this.options)
  }
}



// WEBPACK FOOTER //
// ./src/components/PieChart.js